// components
import PeriodInput from 'components/shared/PeriodInput/PeriodInput';

// libraries
import { useMemo } from 'react';

// hooks
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// types
import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { Period } from 'components/shared/PeriodInput/PeriodInput.types';

const DateTimePeriodSection = () => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });

  const {
    setValue,
    control,
    formState: { errors }
  } = useFormContext<AppointmentFormFieldData>();

  const [appointmentStart, appointmentEnd, recurrenceRule] = useWatch({
    name: ['start', 'end', 'recurrencePattern.recurrenceRule'],
    control
  });

  const { endTimeError } = useMemo(() => {
    return {
      endTimeError: !!errors ? errors['end']?.message : null
    };
  }, [errors]);

  const isRecurring = useMemo(() => recurrenceRule != 'none', [recurrenceRule]);

  const period = useMemo(() => {
    return {
      start: appointmentStart ? new Date(appointmentStart) : new Date(),
      end: appointmentEnd ? new Date(appointmentEnd) : new Date()
    };
  }, [appointmentStart, appointmentEnd]);

  const onChange = (period: Period) => {
    const updateOptions = {
      shouldDirty: true,
      shouldValidate: true
    };

    setValue('start', period.start.toISOString(), updateOptions);
    setValue('end', period.end.toISOString(), updateOptions);
  };

  return (
    <PeriodInput
      label={isRecurring ? t('patternStart') : t('date')}
      period={period}
      error={endTimeError}
      onChange={onChange}
    />
  );
};

export default DateTimePeriodSection;
